<template>
  <div class="slim pb-4">
    <h3 class="block-title text-center" v-if="this.content.meta.title">
      <span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span>
    </h3>
    <content-unit
      :context="context"
      :contentUnit="contentUnit"
      :key="contentUnit.id"
      :outerWrapperClass="'container-fluid'"
      :providerId="providerId"
      :providerInformationBlockId="id"
    >
      <div slot-scope="props" slot="template" class="row text-and-image-container">
        <div
          @click="openPhotoViewer = true"
          class="col-12 col-sm-6 image-container p-0"
          :class="imagePosition === 'right' ? 'order-sm-2 order-1' : 'order-1'"
          :style="imageContainerStyle(props.imageUrl ? props.imageUrl : props.imageData)"
        >
          <img
            ref="img"
            style="visibility:hidden"
            v-if="props.imageData || props.imageUrl"
            :src="props.imageUrl ? props.imageUrl : props.imageData"
          />
        </div>
        <div
          v-if="props.imageData || props.imageUrl"
          class="col-12 col-sm-6 mt-4 mt-sm-0"
          :class="imagePosition === 'right' ? 'order-sm-1 order-2' : 'order-2'"
        >
          <div class="text-container">
            <expandable-text :text="props.text" :max-height="200"></expandable-text>
          </div>
        </div>
      </div>
    </content-unit>
    <photo-viewer
      v-if="openPhotoViewer"
      ref="photoViewer"
      :photos="photo"
      :context="context"
      @close="openPhotoViewer = false"></photo-viewer>
  </div>
</template>

<script>
import providerInformationBlockCommon from "../../mixins/provider-information-block-common";
import PhotoViewer from '../common/PhotoViewer.vue';
export default {
  components: { PhotoViewer },
  props: ["block", "providerId", "context"],
  mixins: [providerInformationBlockCommon],
  methods: {
    imageContainerStyle(src) {
      return {
        maxHeight: '260px',
        backgroundImage: 'url(' + src + ')',
        width: '100%',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }
    },
    openImage(url) {
      if (url) {
        window.open(url, 'ding-image-view');
      }
    }
  },
  mounted() {
    let isMobile = $(this.$refs['mobile-check']).css('display') === 'none';
    if (isMobile) {
      var backgroundPosition = 'center';
    } else {
      var backgroundPosition = this.imagePosition === 'right' ? 'center left' : 'center right';
    }
  },
  data() {
    const content = JSON.parse(this.block.content);
    var contentUnit = content.contentUnit;
    var imagePosition = content.imagePosition || "left";
    if (!contentUnit) {
      contentUnit = this.createEmptyLocalContentUnit();
    }
    return {
      id: this.block.id,
      content: content,
      contentUnit,
      imagePosition,
      informationBlock: this.block.information_block,
      openPhotoViewer: false,
    };
  },
  computed: {
    photo() {
      if (this.contentUnit.file_name) {
        return [{
          path: this.contentUnit.file_name,
        }];
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.text-and-image-container {
  align-items: center;
  padding-top: 12px;
  padding-bottom: 12px;
}

.text-container {
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  word-break: break-word;
}

.order-1 .text-container {
  margin-right: 0%;
  margin-left: auto;
  display: block;
  text-align: left;
}

.order-2 > .text-container > span {
  margin-left: 0%;
  display: block;
  text-align: left;
}

.image-container img {
  width: 100%;
}
</style>
